import React from "react";
import { Box, Paper, Skeleton } from "@mui/material";

/** A Notice's page while it loads from just its address, e.g. opened in a new tab. */
const NoticeDetailsSkeleton: React.FC = () => (
  <Box aria-busy="true" aria-label="Loading Notice" sx={{ p: { xs: 2, md: 3 }, maxWidth: 800, mx: "auto", mt: 2 }}>
    <Skeleton variant="rounded" width={160} height={40} sx={{ mb: 2 }} />
    <Paper elevation={0} sx={{ p: 3, border: 1, borderColor: "divider", borderRadius: 3 }}>
      <Skeleton variant="text" width="60%" height={40} />
      <Skeleton variant="text" width="35%" height={24} sx={{ mb: 2 }} />
      <Skeleton variant="text" />
      <Skeleton variant="text" />
      <Skeleton variant="text" width="80%" />
    </Paper>
  </Box>
);

export default NoticeDetailsSkeleton;
